export interface AkimaConfig {
  container: string | HTMLElement;
  endpoint?: string;
  source?: string;
  labels?: Partial<AkimaLabels>;
  onSuccess?: (result: AkimaResult) => void;
  onError?: (error: AkimaError) => void;
}

export interface AkimaLabels {
  url: string;
  email: string;
  submit: string;
  submitting: string;
  successTitle: string;
  successMessage: string;
}

export interface AkimaSubmitOptions {
  url: string;
  email: string;
  endpoint?: string;
  source?: string;
  privacyConsent?: boolean;
  emailFollowUpConsent?: boolean;
}

export interface AkimaResult {
  assessmentId: string;
  status: string;
  estimatedTime: string;
}

export interface AkimaError {
  message: string;
  details?: Array<{ path: (string | number)[]; message: string }>;
}

export interface ValidationError {
  field: string;
  message: string;
}

export const DEFAULT_ENDPOINT = "https://akima-hub.vercel.app/api/assessments";

export const DEFAULT_LABELS: AkimaLabels = {
  url: "Website URL",
  email: "E-Mail-Adresse",
  submit: "Analyse starten",
  submitting: "Wird gesendet...",
  successTitle: "Analyse gestartet!",
  successMessage:
    "Sie erhalten die Ergebnisse in wenigen Minuten per E-Mail.",
};
